<template>
  <div class="index-bg">
    <!-- 轮播 -->
    <div class="banner" v-if="$store.state.webInfo.base_conf.is_banner == 1">
      <swiper
        :options="swiperOptionsbanner"
        ref="mySwiper"
        style="height:438px;"
      >
        <swiper-slide
          v-for="items in banner"
          :key="items.id"
          style="height: 438px; overflow: hidden; background-color: #fff"
        >
          <a :to="items.url">
            <img
              @click="bannergo(items.url, items.url_type)"
              :src="items.image"
              onerror='src="/static/img/banner.png"'
              class="xy-middle"
              style="width: auto; height: 100%"
            />
          </a>
        </swiper-slide>

        <div class="swiper-pagination" slot="pagination"></div>
        <div
          class="swiper-button-prev swiper-botton-white"
          slot="button-prev"
        ></div>
        <div
          class="swiper-button-next swiper-botton-white"
          slot="button-next"
        ></div>
      </swiper>
      <!-- <el-carousel
      :interval="5000"
        trigger="click"
        arrow="always"
        style="height: 438px; min-width: 1200px; margin: auto"
      >
       <transition name="el-fade-in"  v-for="items in banner"
          :key="items.id">
        <el-carousel-item

          style="height: 438px; overflow: hidden; background-color: #fff"
        >
          <h3 style="background: #f0f0f8; opacity: 1; line-height: 397px">
            <a :to="items.url">
              <img
                @click="bannergo(items.url, items.url_type)"
               :src="items.image"
                onerror='src="/static/img/banner.png"'
                class="xy-middle"

                style="width: auto; height: 100%"
              />
            </a>
          </h3>
        </el-carousel-item>

      </transition>
      </el-carousel> -->
    </div>

    <div v-for="special in specialgoods" :key="special.id">
      <div
        class="ys1"
        v-if="
          special.is_image == 2 && special.type == 1 && special.item.length > 0
        "
      >
        <div class="styleTitle">
          <h2 class="titleys x-middle">
            <span>{{ special.name }}</span>
          </h2>
        </div>
        <!-- <el-carousel :interval="4000" :autoplay="newgoodshow" >
    <el-carousel-item v-for="item in 6" :key="item">
      <h3 class="medium">{{ item }}</h3>
    </el-carousel-item>
  </el-carousel> -->
        <div class="recommendPage">
          <swiper :options="swiperOptions" ref="mySwiper">
            <swiper-slide v-for="items in special.item" :key="items.id">
              <div
                class="grid-content bg-purple-light tx"
                :style="
                  $store.state.webInfo.market_status == 1
                    ? 'height:290px'
                    : 'height:274px'
                "
              >
                <!--  :to="{name:'Detail',params: {id: items.id}}" -->
                <router-link
                  tag="a"
                  target="_blank"
                  :to="{ name: 'Detail', params: { id: items.id } }"
                >
                  <img
                    style="width: 160px; height: 160px"
                    v-lazy="items.image"
                    onerror="src='/static/imgout2.png'"
                    alt
                    lazy
                  />
                  <!-- :title="items.name" -->
                  <p class="goodsName ellipseal" style="text-align: left">
                    <span class="jd" v-show="items.source == 1">优选</span>
                    <span class="yx" v-show="items.source == 6">严选</span>
                    <span class="new" v-show="items.source == 2">直充</span>

                    <span class="rob" v-show="items.source == 3">卡券</span>

                    {{ items.name }}
                  </p>
                  <p class="paddingL20 price text-left">
                    <span class="theme-col">
                      <span v-if="items.price_points" class="price" style="font-size: 16px">
                        {{ items.price_points }}{{ $store.state.name }}
                      </span>
                      <span class="price" style="font-size: 16px" v-if="items.price_cash">
                        <span v-if="items.price_points">+</span>{{ items.price_cash }}元
                      </span>
                    </span>
                  </p>
                  <p
                    class="mark_point"
                    v-if="$store.state.webInfo.market_status == 1"
                    style="
                      font-size: 12px;
                      text-decoration: line-through;
                      color: #9d9d9d;
                    "
                  >
                    <span>市场价¥:{{ items.market_price }}</span>
                  </p>
                  <p
                    class="stock"
                    v-if="items.stock_status == 1 && $store.state.mallStockShow == 1"
                    style="
                      font-size: 12px;
                      color: #9d9d9d;
                    "
                  >
                    <span>库存：{{ items.stock_number }}</span>
                  </p>
                </router-link>
                <div
                  class="add"
                  @click="addcart(items.id)"
                  v-if="(items.source != 3) & (items.source != 2)"
                >
                  <img
                    style="width:22px;margin-right:10px;"
                    src="/static/img/cart-icon.svg"
                  />加入购物车
                </div>
              </div>
            </swiper-slide>

            <!-- <div class="swiper-pagination" slot="pagination"></div> -->
            <div
              class="swiper-button-prev swiper-botton-white"
              slot="button-prev"
            ></div>
            <div
              class="swiper-button-next swiper-botton-white"
              slot="button-next"
            ></div>
          </swiper>
        </div>
      </div>

      <div
        class="ys1"
        v-if="
          special.is_image == 3 && special.type == 1 && special.item.length > 0
        "
      >
        <div class="styleTitle">
          <h2 class="titleys x-middle">
            <span>{{ special.name }}</span>
          </h2>
        </div>
        <div class="div1" style="width: 1190px; margin: 0 atuo">
          <el-row>
            <el-col class="ztanimate" style="width: 230px">
              <router-link
                :to="{
                  name: 'Goodslist',
                  query: { classid: special.clas_id, stype: 1 }
                }"
              >
                <img
                  style="width: 230px"
                  v-lazy="special.image"
                  onerror="src='/static/img/srzq.png'"
                  alt
                  lazy
                  src="/static/imgout2.png"
                  :style="
                    $store.state.webInfo.market_status == 1 || $store.state.mallStockShow == 1
                      ? 'height:314px'
                      : 'height:304px'
                  "
                />
              </router-link>
            </el-col>
            <el-col
              class="tx"
              style="
                width: 230px;
                padding: 10px;
                margin: 0 0 10px 10px;
                background: #fff;
              "
              :style="
                $store.state.webInfo.market_status == 1 || $store.state.mallStockShow == 1
                  ? 'height:314px'
                  : 'height:304px'
              "
              v-for="(items, index) in special.item"
              :key="items.id"
              v-if="index < 4"
            >
              <div class="grid-content bg-purple-light">
                <!--   :to="{ name: 'Detail', params: { id: items.id } }" -->
                <router-link
                  tag="a"
                  target="_blank"
                  :to="{ name: 'Detail', params: { id: items.id } }"
                  style="padding-bottom: 5px"
                >
                  <!--  v-lazy="items.image" -->
                  <img
                    v-lazy="items.image"
                    onerror="src='/static/imgout2.png'"
                    alt
                    style="width: 200px; height: 200px"
                    lazy
                  />
                  <!--  :title="items.name" -->
                  <p class="goodsName ellipseal" style="text-align: left">
                    <span class="jd" v-show="items.source == 1">优选</span>
                    <span class="yx" v-show="items.source == 6">严选</span>
                    <span class="new" v-show="items.source == 2">直充</span>
                    <!-- v-show="items.source == 3" -->
                    <span class="rob" v-show="items.source == 3">卡券</span>
                    {{ items.name }}
                  </p>
                  <p class="paddingL20 price text-left">
                    <span class="theme-col">
                      <span style="" v-if="items.price_points">
                        {{ items.price_points }}{{ $store.state.name }}
                      </span>
                      <span v-if="items.price_cash">
                        <span v-if="items.price_points">+</span>{{ items.price_cash }}元
                      </span>
                    </span>
                    <div class="flex-box">
                      <p
                        class="stock"
                        v-if="items.stock_status == 1 && $store.state.mallStockShow == 1"
                        style="
                          font-size: 12px;
                          color: #9d9d9d;
                        "
                      >
                        <!--  -->
                        <span>库存：{{ items.stock_number }}</span>
                      </p>
                      <p
                        class="mark_point"
                        v-if="$store.state.webInfo.market_status == 1"
                        style="
                          font-size: 12px;
                          text-decoration: line-through;
                          color: #9d9d9d;
                        "
                      >
                        <!--  -->
                        <span>市场价¥:{{ items.market_price }}</span>
                      </p>
                      
                    </div>
                    
                  </p>
                </router-link>
              </div>
              <div
                class="add"
                @click="addcart(items.id)"
                v-if="(items.source != 3) & (items.source != 2)"
              >
                <img
                  style="width:22px;margin-right:10px;"
                  src="/static/img/cart-icon.svg"
                />加入购物车
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 京东专区 -->
      <div
        class="jdzhuanqu"
        v-if="
          special.is_image == 1 && special.type == 1 && special.item.length > 0
        "
      >
        <div>
          <div class="styleTitle">
            <h2 class="titleys x-middle">{{ special.name }}</h2>
          </div>
          <el-row>
            <el-col class="ztanimate" style="width: 710px">
              <router-link
                :to="{
                  name: 'Goodslist',
                  query: { classid: special.clas_id, stype: 1 }
                }"
              >
                <img
                  v-lazy="special.image"
                  onerror="src='/static/img/srzq.png'"
                  alt
                  style="width: 710px"
                  lazy
                  :style="{
                    height: $store.state.webInfo.market_status == 1 || $store.state.mallStockShow == 1 ? '341px' : '319px'
                  }"
                />
              </router-link>
            </el-col>
            <el-col
              style="
                width: 230px;
                padding: 10px;
                margin-left: 10px;
              "
              v-for="(items, index) in special.item"
              :key="items.id"
              v-if="index < 7"
              class="tx"
              :style="{
                height: $store.state.webInfo.market_status == 1 || $store.state.mallStockShow == 1 ? '341px' : '319px'
              }"
            >
              <div class="grid-content bg-purple-light">
                <router-link
                  tag="a"
                  target="_blank"
                  :to="{ name: 'Detail', params: { id: items.id } }"
                  style="padding-bottom: 5px"
                >
                  <img
                    v-lazy="items.image"
                    onerror="src='/static/imgout2.png'"
                    alt
                    style="width: 210px; height: 210px"
                    lazy
                  />
                  <p
                    class="goodsName ellipseal"
                    style="text-align: left"
                    :title="items.name"
                  >
                    <span class="jd" v-show="items.source == 1">优选</span>
                    <span class="yx" v-show="items.source == 6">严选</span>
                    <span class="new" v-show="items.source == 2">直充</span>
                    <span class="rob" v-show="items.source == 3">卡券</span>
                    {{ items.name }}
                  </p>
                  <p class="paddingL20 price text-left">
                    <span class="theme-col">
                      <span class="price" style="font-size: 16px" v-if="items.price_points">
                        {{ items.price_points }}{{ $store.state.name }}
                      </span>
                      <span v-if="items.price_cash">
                        <span v-if="items.price_points">+</span>{{ items.price_cash }}元
                      </span>
                    </span>
                    
                  </p>
                  <div class="flex-box" style="margin-top: 10px;">
                    <span
                      class="stock"
                      v-if="items.stock_status === 1 && $store.state.mallStockShow"
                      style="
                        font-size: 12px;
                        color: #9d9d9d;
                      "
                    >
                      <!--  -->
                      <span>库存：{{ items.stock_number }}</span>
                    </span>
                    <span
                      class="mark_point"
                      v-if="$store.state.webInfo.market_status == 1"
                      style="
                        font-size: 12px;
                        text-decoration: line-through;
                        color: #9d9d9d;
                      "
                    >
                      <!--  -->
                      <span>市场价¥:{{ items.market_price }}</span>
                    </span>
                  </div>
                </router-link>
              </div>
              <div
                class="add"
                @click="addcart(items.id)"
                v-if="(items.source != 3) & (items.source != 2)"
              >
                <img
                  style="width:22px;margin-right:10px;"
                  src="/static/img/cart-icon.svg"
                />加入购物车
              </div>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- 优选专区 -->
      <div
        class="ys1"
        v-if="
          special.is_image == 4 && special.type == 1 && special.item.length > 0
        "
      >
        <div class="styleTitle">
          <h2 class="titleys x-middle">
            <span>{{ special.name }}</span>
          </h2>
        </div>
        <div class="div1" style="width: 1190px; margin: 0 atuo">
          <div class="ztanimate" style="float: left">
            <router-link
              :to="{
                name: 'Goodslist',
                query: { classid: special.clas_id, stype: 1 }
              }"
            >
              <img
                style="width: 230px"
                v-lazy="special.image"
                onerror="src='/static/img/srzq.png'"
                alt
                :style="
                  $store.state.webInfo.market_status == 1 || $store.state.mallStockShow == 1
                    ? 'height:658px'
                    : 'height:618px'
                "
              />
            </router-link>
          </div>
          <div style="float: left">
            <el-row style="width: 960px">
              <el-col
                v-for="(items, index) in special.item"
                :key="items.id"
                class="tx"
                style="
                  width: 230px;
                  padding: 10px;
                  margin: 0 0 10px 10px;
                  background: #fff;
                "
                :style="
                  $store.state.webInfo.market_status == 1 || $store.state.mallStockShow == 1
                    ? 'height:324px'
                    : 'height:304px'
                "
                v-if="index < 8"
              >
                <div class="grid-content bg-purple-light">
                  <!--   :to="{ name: 'Detail', params: { id: items.id } }" -->
                  <router-link
                    tag="a"
                    target="_blank"
                    :to="{
                      name: 'Goodslist',
                      query: { classid: special.clas_id, stype: 1 }
                    }"
                    style="padding-bottom: 5px"
                  >
                    <!--  v-lazy="items.image" -->
                    <img
                      v-lazy="items.image"
                      onerror="src='/static/imgout2.png'"
                      alt
                      style="width: 200px; height: 200px"
                      lazy
                    />
                    <!--  :title="items.name" -->
                    <p class="goodsName ellipseal" style="text-align: left">
                      <span class="jd" v-show="items.source == 1">优选</span>
                      <span class="yx" v-show="items.source == 6">严选</span>
                      <span class="new" v-show="items.source == 2">直充</span>
                      <!-- v-show="items.source == 3" -->
                      <span class="rob" v-show="items.source == 3">卡券</span>
                      {{ items.name }}
                    </p>
                    <p class="paddingL20 price text-left">
                      <span class="theme-col">
                        <span style="" v-if="items.price_points">
                          {{ items.price_points }}{{ $store.state.name }}
                        </span>
                        <span v-if="items.price_cash">
                          <span v-if="items.price_points">+</span>{{ items.price_cash }}元
                        </span>
                      </span>
                      
                    </p>
                    <div class="flex-box" style="margin-top: 10px;">
                      <span
                        class="mark_point"
                        v-if="items.stock_status === 1 && $store.state.mallStockShow == 1"
                        style="
                          font-size: 12px;
                          color: #9d9d9d;
                        "
                      >
                        <span>库存：{{ items.stock_number }}</span>
                      </span>
                      <span
                        class="mark_point"
                        v-if="$store.state.webInfo.market_status == 1"
                        style="
                          font-size: 12px;
                          text-decoration: line-through;
                          color: #9d9d9d;
                        "
                      >
                        <!-- {{ items.market_price }} -->
                        <span>市场价:¥{{ items.market_price }}</span>
                      </span>
                    </div>
                  </router-link>
                </div>
                <div
                  class="add"
                  @click="addcart(items.id)"
                  v-if="items.source != 3 || items.source != 2"
                >
                  <img
                    style="width:22px;margin-right:10px;"
                    src="/static/img/cart-icon.svg"
                  />加入购物车
                </div>
              </el-col>
            </el-row>
          </div>
          <div style="clear: both"></div>
        </div>
      </div>
      <!-- 品质专区 -->
      <div
        class="ys1"
        v-if="
          special.is_image == 5 && special.type == 1 && special.item.length > 0
        "
      >
        <div class="">
          <div class="styleTitle">
            <h2 class="titleys x-middle">
              <span>{{ special.name }}</span>
            </h2>
          </div>
          <div class="div1 div2" style="width: 1190px; margin: 0 atuo">
            <div class="ztanimate" style="margin-bottom: 10px">
              <router-link
                :to="{
                  name: 'Goodslist',
                  query: { classid: special.clas_id, stype: 1 }
                }"
              >
                <img
                  style="width: 1190px; height: 265px"
                  v-lazy="special.image"
                  onerror="src='/static/img/srzq.png'"
                  alt
                />
              </router-link>
            </div>
            <el-row>
              <el-col
                class="tx"
                style="
                  width: 230px;
                  padding: 10px;
                  margin: 0 0 10px 10px;
                  background: #fff;
                "
                v-for="(items, index) in special.item"
                :key="items.id"
                :style="
                  $store.state.webInfo.market_status == 1 || $store.state.mallStockShow == 1
                    ? 'height:324px'
                    : 'height:304px'
                "
              >
                <div class="grid-content bg-purple-light">
                  <!--   :to="{ name: 'Detail', params: { id: items.id } }" -->
                  <router-link
                    tag="a"
                    target="_blank"
                    :to="{ name: 'Detail', params: { id: items.id } }"
                    style="padding-bottom: 5px"
                  >
                    <!--  v-lazy="items.image" -->
                    <img
                      v-lazy="items.image"
                      onerror="src='/static/imgout2.png'"
                      alt
                      style="width: 200px; height: 200px"
                      lazy
                    />
                    <!--  :title="items.name" -->
                    <p class="goodsName ellipseal" style="text-align: left">
                      <span class="jd" v-show="items.source == 1">优选</span>
                      <span class="yx" v-show="items.source == 6">严选</span>
                      <span class="new" v-show="items.source == 2">直充</span>
                      <!-- v-show="items.source == 3" -->
                      <span class="rob" v-show="items.source == 3">卡券</span>
                      {{ items.name }}
                    </p>
                    <p class="paddingL20 price text-left">
                      <span class="theme-col">
                        <span v-if="items.price_points">
                          {{ items.price_points }}{{ $store.state.name }}
                        </span>
                        <span v-if="items.price_cash">
                          <span v-if="items.price_points">+</span>{{ items.price_cash }}元
                        </span>
                      </span>
                    </p>
                    <div class="flex-box" style="margin-top: 10px;">
                      <span
                        class="mark_point"
                        v-if="items.stock_status === 1 && $store.state.mallStockShow"
                        style="
                          font-size: 12px;
                          color: #9d9d9d;
                        "
                      >
                        <span>库存：{{ items.stock_number }}</span>
                      </span>
                      <span
                        class="mark_point"
                        v-if="$store.state.webInfo.market_status == 1"
                        style="
                          font-size: 12px;
                          text-decoration: line-through;
                          color: #9d9d9d;
                        "
                      >
                        <!-- {{ items.market_price }} -->
                        <span>市场价:¥{{ items.market_price }}</span>
                      </span>
                    </div>
                  </router-link>
                </div>
                <div
                  class="add"
                  @click="addcart(items.id)"
                  v-if="items.source != 3 || items.source != 2"
                >
                  <img
                    style="width:22px;margin-right:10px;"
                    src="/static/img/cart-icon.svg"
                  />加入购物车
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>

      <!-- 猜你喜欢 -->
      <div
        class="youlike"
        v-if="
          special.is_image == 0 && special.type == 1 && special.item.length > 0
        "
      >
        <div class="styleTitle">
          <h2 class="titleys x-middle">
            <span>{{ special.name }}</span>
          </h2>
        </div>
        <div style="margin-bottom: 30px; font-size: 18px">
          {{ special.subheading }}
        </div>
        <el-row>
          <el-col
            class="tx"
            style="width: 230px; padding: 10px 10px; margin: 0 0 10px 10px"
            :style="
              $store.state.webInfo.market_status == 1
                ? 'height:335px'
                : 'height:319px'
            "
            v-for="items in special.item"
            :key="items.id"
          >
            <div class="grid-content bg-purple-light">
              <router-link
                tag="a"
                target="_blank"
                :to="{ name: 'Detail', params: { id: items.id } }"
                style="padding-bottom: 5px"
              >
                <img
                  v-lazy="items.image"
                  onerror="src='/static/imgout2.png'"
                  alt
                  style="width: 210px;height:210px;"
                  lazy
                />
                <p
                  class="goodsName ellipseal"
                  style="text-align: left; margin-top: 5px"
                  :title="items.name"
                >
                  <span class="jd" v-show="items.source == 1">优选</span>
                  <span class="yx" v-show="items.source == 6">严选</span>
                  <span class="new" v-show="items.source == 2">直充</span>
                  <span class="rob" v-show="items.source == 3">卡券</span>
                  {{ items.name }}
                </p>
                <p class="paddingL20 price text-left">
                  <span class="theme-col">
                    <span class="price" style="font-size: 16px" v-if="items.price_points">
                      {{ items.price_points }}{{ $store.state.name }}
                    </span>
                    <span v-if="items.price_cash">
                      <span v-if="items.price_points">+</span>{{ items.price_cash }}元
                    </span>
                  </span>
                </p>
                <div class="flex-box">
                  <span
                    class="stock"
                    v-if="items.stock_status === 1 && $store.state.mallStockShow"
                    style="
                      font-size: 12px;
                      color: #9d9d9d;
                    "
                  >
                    <!--  -->
                    <span>库存：{{ items.stock_number }}</span>
                  </span>
                  <p
                    class="price text-left"
                    style="margin-top: 0px"
                    v-if="$store.state.webInfo.market_status == 1"
                  >
                    <span
                      class="mark_point"
                      v-if="$store.state.webInfo.market_status == 1"
                      style="
                        font-size: 12px;
                        text-decoration: line-through;
                        color: #9d9d9d;
                      "
                    >
                      <!--  -->
                      <span>市场价¥:{{ items.market_price }}</span>
                    </span>
                  </p>
                </div>
                
              </router-link>
            </div>
            <div
              class="add"
              @click="addcart(items.id)"
              v-if="items.source != 3 || items.source != 2"
            >
              <img
                style="width:22px;margin-right:10px;"
                src="/static/img/cart-icon.svg"
              />加入购物车
            </div>
          </el-col>
        </el-row>
      </div>

      <div
        class="content"
        v-if="special.type == 2"
        :class="special.imglist_style ? 'content' + special.imglist_style : ''"
      >
        <div
          class="item "
          v-for="(items, index1) in special.imglist"
          :key="index1"
        >
          <a :href="items.link ? items.link : 'javascript:void(0)'">
            <img
              class="ztanimate"
              v-if="items.file_image.image_url"
              :src="items.file_image.image_url"
            />
          </a>
        </div>
      </div>
    </div>

    <CustomerService></CustomerService>
  </div>
</template>

<script>
import store from "../../vuex/store";

import { swiper, swiperSlide, directive } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
import Mixins from "../../../static/js/mixins";
import CustomerService from "@/common/CustomerService";
export default {
  name: "Index",
  data() {
    return {
      swiperOptions: {
        slidesPerView: 6,
        //  autoplay:{depaly:3000},
        observer: true,
        fadeEffect: {
          crossFade: true
        },
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true,
        // },

        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      swiperOptionsbanner: {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        observeParents: false, //必须加入
        observer: true, //必须加入

        effect: "fade",
        speed: 1000,
        fadeEffect: {
          crossFade: true
        },
        // loop:true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        autoplay: {
          disableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay （没有加入之前轮播图设置 autoplay：true无效）
          delay: 3500 // 自动切换的时间间隔（单位ms）
        }
      },
      banner: "", //轮播图
      datas: "", //商品信息
      jdgoods: "", //京东专区
      birthdaygoods: "", //生日专区
      recommendgoods: "", //超值推荐
      newgoods: "", //新品推荐
      newgoodshow: false,
      specialgoods: "" //专题商品
    };
  },
  mixins: [Mixins],
  components: {
    swiper,
    swiperSlide,
    CustomerService
  },
  computed: {
    swiper() {
      console.log(this.$refs.mySwiper.$swiper);
      return this.$refs.mySwiper.$swiper;
    }
  },
  store,
  methods: {
    bannergo(url, type) {
      if (type == 0) {
        //          var reg='http://'+this.host+'/'
        //          var str = url.replace(reg,"");
        //          this.$router.push({path:str})
        // this.$router.push({path:url})
      } else if (url == "http://" || url == "") {
      } else {
        window.location.href = url;
      }
    },
    //获取轮播图
    getbnner: function() {
      this.$api.get(
        "sys/banner",
        { id_example: this.$store.state.id_example, terminal: "pc" },
        res => {
          if (res.data.data.length != 0) {
            this.banner = res.data.data;
            this.$nextTick(() => {});
          }
        }
      );
    },
    //获取首页专题商品数据
    getdatas: function() {
      var _this = this;
      this.$api.get(
        "sys/subject",
        { id_example: this.$store.state.id_example, terminal: "pc" },
        res => {
          if (res.data.code == 100) {
            this.specialgoods = res.data.data;
            console.log(this.specialgoods);
            // var _this = this;
            // $.each(res.data.data,  (index, items)=> {
            //   console.log(items)
            //   if (items.name == "超值新品") {
            //     this.newgoodshow = true;
            //   } else if (items.name == "精品推荐") {
            //     this.newgoodshow = true;
            //   }
            // });
          }
        }
      );
    }
  },
  mounted() {
    this.getbnner();
    this.getdatas();
    //  this.$refs.mySwiper.swiper.slideTo(3, 1000, false)
    console.log(this.$refs.mySwiper);
  }
};
</script>

<style lang="less" scoped>
.content {
  width: 1190px;
  margin: 0 auto;
  display: flex;
  margin-top: 40px;
  justify-content: space-between;
  
  .item {
    width: 100%;
    height: 317px;
    // background-color: #fff;
    // background-image: url(../../../assets/img/tu.png);
    background-repeat: no-repeat;
    background-position: center;
    background: none;
    // border-radius: 8px;
    position: relative;
    box-sizing: border-box;
    // border: 1px solid #d6dee9;
    p {
      border: 0px;
      width: 100%;
      bottom: 10px;
      position: absolute;
      bottom: 10px;
      text-align: center;
    }
    img {
      width: 100%;
      height: 100%;
      display: inline-block !important;
    }
  }

  &.content1 {
    .item {
      width: 100%;
      // margin: 0px 2px;
    }
  }
  &.content2 {
    flex-wrap: nowrap;
    .item {
      width: 50%;
      &:first-child {
        padding-right: 5px;
      }
      &:last-child {
        padding-left: 5px;
      }
    }
  }
  &.content3 {
    flex-wrap: wrap;
    .item {
      &:first-child {
        margin-bottom: 5px;
      }
      &:last-child {
        margin-top: 5px;
      }
    }
  }
  &.content4 {
    flex-wrap: nowrap;
    .item {
      width: 33.33%;
      // margin: 2px 0px;
      padding: 0px 5px;
      &:first-child {
        padding-left: 0px;
      }
      &:last-child {
        padding-right: 0px;
      }
    }
  }
  &.content5 {
    flex-wrap: wrap;
    .item {
      width: 50%;
      &:first-child {
        padding-right: 5px;
      }
      &:nth-child(2) {
        padding-left: 5px;
      }
      &:last-child {
        width: 100%;
        margin-top: 10px;
      }
    }
  }
  &.content6 {
    flex-wrap: wrap;
    .item {
      width: 50%;
      // margin: 2px 0px;
      &:first-child {
        width: 100%;
        margin-bottom: 10px;
        margin-left: 0px;
        margin-right: 0px;
      }
      &:last-child {
        padding-left: 5px;
      }
      &:nth-child(2) {
        padding-right: 5px;
      }
    }
  }
  &.content7 {
    flex-wrap: nowrap;
    .item {
      width: 25%;
      padding: 0px 5px;
      &:first-child {
        padding-left: 0px;
      }
      &:last-child {
        padding-right: 0px;
      }
    }
  }
  &.content8 {
    flex-wrap: wrap;
    .item {
      width: 33.33%;
      padding: 0px 5px;
      &:last-child {
        width: 100%;
        margin-top: 10px;
        padding-right: 0px;
        padding-right: 0px;
      }
      &:first-child {
        margin-left: 0px;
        padding-left: 0px;
      }
      &:nth-child(3) {
        padding-right: 0px;
      }
      &:last-child {
        padding-right: 0px;
        padding-left: 0px;
      }
    }
  }
  &.content9 {
    flex-wrap: wrap;
    .item {
      width: 30%;
      padding: 0px 5px;
      &:first-child {
        width: 100%;
        padding: 0px;
        margin-bottom: 10px;
      }
      &:nth-child(2) {
        padding-left: 0px;
      }
      &:last-child {
        padding-right: 0px;
      }
    }
  }
  &.content10 {
    flex-wrap: wrap;
    .item {
      width: 50%;
      padding: 0px 5px;
      // margin: 2px 0px;
      &:first-child {
        width: 100%;
        padding-left: 0px;
      }
      &:nth-child(2) {
        padding-right: 0px;
      }
      &:last-child {
        width: 100%;
        margin-top: 10px;
        padding: 0px;
      }
      &:nth-child(3) {
        width: 100%;
        margin-top: 10px;
        padding: 0px;
      }
    }
  }
  &.content11 {
    flex-wrap: wrap;
    .item {
      width: 50%;
      //
      padding: 0px 5px;
      &:nth-child(2) {
        padding-left: 0px;
      }
      &:nth-child(3) {
        padding-right: 0px;
      }
      &:last-child {
        width: 100%;
        margin-top: 110px;
      }
      &:first-child {
        width: 100%;
        margin-bottom: 10px;
      }
    }
  }
  &.content12 {
    flex-wrap: wrap;
    .item {
      width: 25%;
      padding: 0px 5px;
      &:first-child {
        padding-left: 0px;
      }
      &:nth-child(4) {
        padding-right: 0px;
      }
      &:last-child {
        width: 100%;
        margin-top: 10px;
      }
    }
  }
}
.flex-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.el-carousel__item.is-animating {
  -webkit-transition: -webkit-transform 4s ease-in-out;
  transition: -webkit-transform 4s ease-in-out;
  transition: transform 4s ease-in-out;
  transition: transform 4s ease-in-out, -webkit-transform 4s ease-in-out;
}
.ztanimate {
  transition: all 0.2s linear;
  &:hover {
    transform: translate3d(0, -2px, 0);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  }
}

.div1 {
  width: 1190px;
  margin: 0 auto;
  .price {
    margin-top: 5px;
    text-align: center;
  }
}
.div2 {
  .el-col-24:nth-child(5n + 1) {
    margin-left: 0px !important;
  }
}

.recommendPage {
  width: 1190px;
  margin: 0 auto;
  position: relative;
  .swiper-container {
    height: 100%;
    overflow: hidden;
    --swiper-theme-color: #ff6600; /* 设置Swiper风格 */
    --swiper-navigation-color: #fff; /* 单独设置按钮颜色 */
    --swiper-navigation-size: 18px; /* 设置按钮大小 */
  }
  .swiper-button-prev {
    border-radius: 0px 50% 50% 0px;
  }
  .swiper-button-prev,
  .swiper-container-rtl .swiper-button-next {
    left: 0px;
    right: auto;
    border-radius: 0px 50% 50% 0px;
    width: 35px;
    height: 30px;
    background: rgba(38, 38, 38, 0.5);
  }
  .swiper-button-next,
  .swiper-container-rtl .swiper-button-prev {
    right: 0px;
    left: auto;
    border-radius: 50% 0px 0px 50%;
    width: 35px;
    height: 30px;
    background: rgba(38, 38, 38, 0.5);
  }
  .tx {
    box-shadow: none;
    transition: all 0.2s linear;

    a img {
      transition: all 0.25s ease;
    }
    .add {
      width: 198px;
      cursor: pointer;
    }
  }
  .tx:hover {
    z-index: 10000;
    transform: translate3d(0, 0px, 0);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1) !important;
    line-height: 48px;
    a img {
      opacity: 0.9;
    }
  }
  .grid-content {
    padding: 24px 19px 10px 19px;
    height: 274px;
    box-sizing: border-box;
    overflow: hidden;
    background: #fff;
    .goodsName {
      margin: 0 auto;
      padding-top: 10px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
      width: 160px;
      height: 24px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: #272727;
      line-height: 24px;
    }
    .price {
      height: 21px;
      font-size: 16px;
      font-family: MicrosoftYaHei;
      color: #e53940;
      line-height: 21px;
      text-align: center;
      margin-top: 5px;
    }
    .mark_point {
      height: 16px;
      font-size: 12px;
      font-family: MicrosoftYaHei;
      color: #989898;
      line-height: 16px;
      text-align: center;
      text-decoration: line-through;
      margin-top: 4px;
    }
    .stock {
      height: 16px;
      font-size: 12px;
      font-family: MicrosoftYaHei;
      color: #989898;
      line-height: 16px;
      text-align: center;
      margin-top: 4px;
    }
  }
}

.banner {
  .swiper-container {
    --swiper-theme-color: #fff; /* 设置Swiper风格 */
    --swiper-navigation-color: #fff; /* 单独设置按钮颜色 */
    --swiper-navigation-size: 10px; /* 设置按钮大小 */
  }
  .swiper-button-prev,
  .swiper-container-rtl .swiper-button-next {
    left: 0px;
    right: auto;
    border-radius: 0px;
    width: 38px;
    height: 38px;
  }
  .swiper-button-next,
  .swiper-container-rtl .swiper-button-prev {
    right: 0px;
    left: auto;
    border-radius: 0px;
    width: 38px;
    height: 38px;
  }
  .swiper-button-next,
  .swiper-button-prev {
    &:hover {
      background: rgba(0, 0, 0, 0.5);
    }
  }
}
.titleys {
  height: 37px;
  font-size: 28px;
  font-family: MicrosoftYaHei;
  color: #262626;
  line-height: 37px;

  font-weight: 400;
  span {
    padding: 0px 60px;
    display: inline-block;
  }
}
.x-middle {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.styleTitle {
  width: 1190px;
  margin: auto;
  margin-bottom: 15px;
  overflow: hidden;
  position: relative;
  height: 70px;
  h2 {
    padding: 18px 0px 15px 0px;
    white-space: nowrap;
  }
  h2:after {
    content: url(/static/img/border.png);
    padding-left: 18px;
    position: relative;
    top: -5px;
    // right:5px;
  }
  h2:before {
    content: url(/static/img/border.png);
    padding-right: 18px;
    position: relative;
    top: -5px;
  }
  .styleTitle {
    position: relative;
    height: 93px;
    overflow: hidden;
    img {
      position: absolute;
      width: 500px;
    }
  }
}

.goodsName {
  height: 48px;
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: #272727;
  line-height: 24px;
  margin-top: 5px;
}
.price {
  height: 21px;
  font-size: 16px;
  font-family: MicrosoftYaHei;
  color: #e53940;
  line-height: 21px;
}

.tx {
  overflow: hidden;
  position: relative;
  transition: all 0.2s linear;

  .add {
    height: 48px;
    background: #e23130;
    box-shadow: 0px 0px 15px 0px rgba(153, 153, 153, 0.31);
    position: absolute;
    width: 230px;
    left: 0;
    line-height: 48px;
    color: #fff;
    bottom: -60px;
    transition: bottom 0.25s ease;
    cursor: pointer;
  }
  a img {
    transition: all 0.25s ease;
  }
  &:hover {
    transform: translate3d(0, -2px, 0);
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1) !important;
    .price {
      font-size: 18px !important;
      text-align: center;
      margin-top: 10px;
    }
    .goodsName {
      display: none;
    }
    .mark_point {
      display: none;
    }
    .stock {
      display: none;
    }
    a img {
      opacity: 0.9;
    }
    .add {
      bottom: 0px;
    }
  }
}
.title {
  width: 1190px;
  margin: auto;
  margin-bottom: 50px;
  h2 {
    margin-top: 33px;
    white-space: nowrap;
  }
  h2:after {
    content: url(/static/img/border.png);
    padding-left: 18px;
    position: relative;
    top: -5px;
    // right:5px;
  }
  h2:before {
    content: url(/static/img/border.png);
    padding-right: 18px;
    position: relative;
    top: -5px;
  }
  .styleTitle {
    position: relative;
    height: 93px;
    overflow: hidden;
    img {
      position: absolute;
      width: 500px;
    }
  }
}
.ys1 {
  margin-top: 40px;
}
.index-bg {
  // background:url('/static/img/index_bg.png');
  background-repeat-y: repeat;
  background-position-x: center;
  padding-bottom: 40px;
  min-height: 600px;
}

.price {
  margin-top: 10px;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 400px;
  margin: 0;
}
.el-carousel__container {
  height: 100%;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.tuijian {
  width: 1190px;
  margin: auto;
  .styleTitle {
    padding: 50px 0 30px 0;
    position: relative;

    img {
      width: 139px;
      position: absolute;
    }
  }
  .tjgoods {
    padding: 0px 18px;
    border-left: 1px solid rgb(246, 246, 246);
  }
  .tjgoods:nth-child(2) {
    border: none;
  }
  .el-row {
    height: 274px;
    background: #fff;
    .more-red {
      width: 81px;
      position: absolute;
      background: #fbcbd7;
      color: #f7406c;
      top: 187px;
      left: 49px;
      padding: 5px 10px;
      border-radius: 15px;
    }
    .more-greed {
      width: 81px;
      position: absolute;
      background: #bef5f0;
      color: #35bcb5;
      top: 187px;
      left: 49px;
      padding: 5px 10px;
      border-radius: 15px;
    }
    .el-col {
      height: 264px;
    }
    .border {
      position: absolute;
      bottom: 0;
      z-index: 100;
      height: 24px;
      width: 228px;
      left: 0;
    }
    .border-red {
      position: absolute;
      bottom: 0;
      z-index: 99;
      height: 9px;
      width: 991px;
      left: 200px;
      /*! autoprefixer: off */
      background: -webkit-gradient(
        linear,
        left top,
        right top,
        from(#fa6899),
        to(#f6ebef)
      );
      /* autoprefixer: on */
      background: linear-gradient(left, #fa6899, #f6ebef); /* 标准的语法 */
    }
    .border-greed {
      position: absolute;
      bottom: 0;
      z-index: 99;
      height: 9px;
      width: 991px;
      left: 200px;
      /*! autoprefixer: off */
      background: -webkit-gradient(
        linear,
        left top,
        right top,
        from(#6adcd4),
        to(#f1f5f6)
      );
      /* autoprefixer: on */
      background: linear-gradient(left, #6adcd4, #f1f5f6); /* 标准的语法 */
    }
  }
}
.jdzhuanqu,
.shengri,
.yxyw,
.pingpai {
  width: 1190px;
  margin: auto;
  margin-top: 40px;
  h2 {
    white-space: nowrap;
  }
  h2:after {
    content: url(/static/img/border.png);
    padding-left: 18px;
    position: relative;
    top: -5px;
    // right:5px;
  }
  h2:before {
    content: url(/static/img/border.png);
    padding-right: 18px;
    position: relative;
    top: -5px;
  }
  .styleTitle {
    position: relative;
    height: 70px;
    overflow: hidden;
    img {
      position: absolute;
      width: 500px;
    }
  }
  .el-col {
    box-sizing: border-box;
    background: #fff;
  }
  .el-col:nth-child(1) {
    position: relative;
    // a{
    //   position: absolute;
    //   top: 200px;
    //   left: 75px;
    //   font-size:20px;
    //   font-weight: 500;
    //   display: block;
    //   width: 528px;
    //   line-height: 35px;
    //   text-align: left;
    //   border-radius: 20px;
    // }
    .more-jd {
      color: rgba(46, 141, 32, 1);
      background: linear-gradient(
        to right,
        rgba(225, 247, 234, 0.8),
        rgba(225, 247, 234, 0)
      );
    }
    .more-sr {
      color: rgba(242, 91, 83, 1);
      background: linear-gradient(
        to right,
        rgba(253, 246, 240, 0.8),
        rgba(245, 191, 165, 0)
      );
    }
    .more-pp {
      color: rgba(74, 61, 235, 1);
      background: linear-gradient(
        to right,
        rgba(235, 243, 254, 0.8),
        rgba(143, 143, 243, 0)
      );
    }
    .more-yxyw {
      color: rgba(35, 96, 160, 1);
      background: linear-gradient(
        to right,
        rgba(226, 243, 253, 0.8),
        rgba(140, 203, 246, 0)
      );
    }
  }
  .el-col:nth-child(4) {
    margin: 10px 0 !important;
  }
  .el-col:nth-child(5) {
    margin-top: 10px !important;
  }
  .el-col:nth-child(6) {
    margin-top: 10px !important;
  }
  .el-col:nth-child(7) {
    margin-top: 10px !important;
  }
  .el-col:nth-child(8) {
    margin-top: 10px !important;
  }
}
.youlike {
  width: 1190px;
  margin: auto;
  margin-bottom: 50px;
  .tx {
    transition: all 0.2s linear;
    &:hover {
      transform: translate3d(0, -2px, 0);
      box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1) !important;
      .price {
        line-height: 48px;
      }
    }
  }
  h2 {
    margin-top: 33px;
    white-space: nowrap;
  }
  h2:after {
    content: url(/static/img/border.png);
    padding-left: 18px;
    position: relative;
    top: -5px;
    // right:5px;
  }
  h2:before {
    content: url(/static/img/border.png);
    padding-right: 18px;
    position: relative;
    top: -5px;
  }
  .styleTitle {
    position: relative;
    height: 93px;
    overflow: hidden;
    img {
      position: absolute;
      width: 500px;
    }
  }
  .el-col {
    box-sizing: border-box;
    background: #fff;
  }
  .el-col:nth-child(5n + 1) {
    margin-left: 0 !important;
  }
}
.jdzhuanqu .bg-purple-light img {
  height: 191px;
}
/deep/ .banner .el-carousel__item.is-animating {
  transition: opacity 1s ease-in-out !important;
}
/deep/ .banner .el-carousel__arrow {
  width: 39px !important;
  height: 39px !important;
  border-radius: 0px !important;
  background: rgba(0, 0, 0, 0) !important;
  top: 72%;
}
/deep/ .banner .el-carousel__arrow--left {
  left: 0px;
}
/deep/ .banner .el-carousel__arrow--right {
  right: 0px;
}
/deep/ .banner .el-carousel__arrow--left:hover {
  background: rgba(0, 0, 0, 0.5) !important;
}
/deep/ .banner .el-carousel__arrow--right:hover {
  background: rgba(0, 0, 0, 0.5) !important;
}
/deep/ .el-carousel__indicator .el-carousel__button {
  width: 9px;
  height: 9px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  margin: 2.5px;
  padding: 0px;
}
/deep/ .el-carousel__indicator.is-active .el-carousel__button {
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/goods/index.vue